import * as ambassadorWixEventsV2Policy from './events-v2-policy-policies.http.js';
import * as ambassadorWixEventsV2PolicyTypes from './events-v2-policy-policies.types.js';
import * as ambassadorWixEventsV2PolicyUniversalTypes from './events-v2-policy-policies.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createPolicy(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEventsV2PolicyUniversalTypes.CreatePolicyRequest,
  ambassadorWixEventsV2PolicyTypes.CreatePolicyRequest,
  ambassadorWixEventsV2PolicyUniversalTypes.CreatePolicyResponse,
  ambassadorWixEventsV2PolicyTypes.CreatePolicyResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixEventsV2Policy.createPolicy(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/policies',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updatePolicy(): __PublicMethodMetaInfo<
  'PATCH',
  { policyId: string },
  ambassadorWixEventsV2PolicyUniversalTypes.UpdatePolicyRequest,
  ambassadorWixEventsV2PolicyTypes.UpdatePolicyRequest,
  ambassadorWixEventsV2PolicyUniversalTypes.UpdatePolicyResponse,
  ambassadorWixEventsV2PolicyTypes.UpdatePolicyResponse
> {
  const payload = { policy: { id: ':policyId' } } as any;

  const getRequestOptions = ambassadorWixEventsV2Policy.updatePolicy(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v2/policies/{policy.id}',
    pathParams: { policyId: 'policyId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deletePolicy(): __PublicMethodMetaInfo<
  'DELETE',
  { policyId: string },
  ambassadorWixEventsV2PolicyUniversalTypes.DeletePolicyRequest,
  ambassadorWixEventsV2PolicyTypes.DeletePolicyRequest,
  ambassadorWixEventsV2PolicyUniversalTypes.DeletePolicyResponse,
  ambassadorWixEventsV2PolicyTypes.DeletePolicyResponse
> {
  const payload = { policyId: ':policyId' } as any;

  const getRequestOptions = ambassadorWixEventsV2Policy.deletePolicy(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v2/policies/{policyId}',
    pathParams: { policyId: 'policyId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryPolicies(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEventsV2PolicyUniversalTypes.QueryPoliciesRequest,
  ambassadorWixEventsV2PolicyTypes.QueryPoliciesRequest,
  ambassadorWixEventsV2PolicyUniversalTypes.QueryPoliciesResponse,
  ambassadorWixEventsV2PolicyTypes.QueryPoliciesResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixEventsV2Policy.queryPolicies(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/policies/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function reorderEventPolicies(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEventsV2PolicyUniversalTypes.ReorderEventPoliciesRequest,
  ambassadorWixEventsV2PolicyTypes.ReorderEventPoliciesRequest,
  ambassadorWixEventsV2PolicyUniversalTypes.ReorderEventPoliciesResponse,
  ambassadorWixEventsV2PolicyTypes.ReorderEventPoliciesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEventsV2Policy.reorderEventPolicies(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/policies/reorder',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getPolicy(): __PublicMethodMetaInfo<
  'GET',
  { policyId: string },
  ambassadorWixEventsV2PolicyUniversalTypes.GetPolicyRequest,
  ambassadorWixEventsV2PolicyTypes.GetPolicyRequest,
  ambassadorWixEventsV2PolicyUniversalTypes.GetPolicyResponse,
  ambassadorWixEventsV2PolicyTypes.GetPolicyResponse
> {
  const payload = { policyId: ':policyId' } as any;

  const getRequestOptions = ambassadorWixEventsV2Policy.getPolicy(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v2/policies/{policyId}',
    pathParams: { policyId: 'policyId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Policy as PolicyOriginal,
  CreatePolicyRequest as CreatePolicyRequestOriginal,
  CreatePolicyResponse as CreatePolicyResponseOriginal,
  UpdatePolicyRequest as UpdatePolicyRequestOriginal,
  UpdatePolicyResponse as UpdatePolicyResponseOriginal,
  UpdatePolicySortIndexRequest as UpdatePolicySortIndexRequestOriginal,
  UpdatePolicySortIndexResponse as UpdatePolicySortIndexResponseOriginal,
  DeletePolicyRequest as DeletePolicyRequestOriginal,
  DeletePolicyResponse as DeletePolicyResponseOriginal,
  QueryPoliciesRequest as QueryPoliciesRequestOriginal,
  QueryV2 as QueryV2Original,
  QueryV2PagingMethodOneOf as QueryV2PagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  Paging as PagingOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryPoliciesResponse as QueryPoliciesResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  Cursors as CursorsOriginal,
  ReorderEventPoliciesRequest as ReorderEventPoliciesRequestOriginal,
  ReorderEventPoliciesRequestReferencePolicyOneOf as ReorderEventPoliciesRequestReferencePolicyOneOfOriginal,
  ReorderEventPoliciesResponse as ReorderEventPoliciesResponseOriginal,
  GetPolicyRequest as GetPolicyRequestOriginal,
  GetPolicyResponse as GetPolicyResponseOriginal,
  EventCopied as EventCopiedOriginal,
  Location as LocationOriginal,
  MapCoordinates as MapCoordinatesOriginal,
  LocationType as LocationTypeOriginal,
  LocationTypeWithLiterals as LocationTypeWithLiteralsOriginal,
  Address as AddressOriginal,
  AddressStreetOneOf as AddressStreetOneOfOriginal,
  StreetAddress as StreetAddressOriginal,
  AddressLocation as AddressLocationOriginal,
  Subdivision as SubdivisionOriginal,
  SubdivisionType as SubdivisionTypeOriginal,
  SubdivisionTypeWithLiterals as SubdivisionTypeWithLiteralsOriginal,
  ScheduleConfig as ScheduleConfigOriginal,
  Recurrences as RecurrencesOriginal,
  Occurrence as OccurrenceOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  EventStatus as EventStatusOriginal,
  EventStatusWithLiterals as EventStatusWithLiteralsOriginal,
  Empty as EmptyOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  CreatePolicyApplicationErrors as CreatePolicyApplicationErrorsOriginal,
  ReorderEventPoliciesApplicationErrors as ReorderEventPoliciesApplicationErrorsOriginal,
} from './events-v2-policy-policies.types.js';
